import React, { useMemo } from 'react';
import { Card, Typography, Progress } from 'antd';
import { useDashboard } from './DashboardContext';
import { buildSystemMetrics, formatNumber } from './dashboardUtils';

const { Text } = Typography;

export default function SystemMetricsCard() {
  const { statistics, isAdmin } = useDashboard();
  const systemMetrics = useMemo(
    () => buildSystemMetrics(statistics?.system_metrics),
    [statistics?.system_metrics],
  );

  if (!isAdmin) return null;

  return (
    <Card
      className="modern-card"
      title={<span className="card-title">System metrics</span>}
      style={{ height: '100%', display: 'flex', flexDirection: 'column' }}
      bodyStyle={{ flex: 1, display: 'flex', flexDirection: 'column', padding: '24px' }}
    >
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', padding: '8px 0' }}>
        {systemMetrics.length > 0 ? systemMetrics.map((metric) => (
          <div key={metric.name} style={{ marginBottom: '24px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
              <Text style={{ fontWeight: 500 }}>{metric.name}</Text>
              <Text style={{ fontWeight: 600 }}>{metric.value?.toFixed(1) || 0}%</Text>
            </div>
            <Progress
              percent={metric.value || 0}
              strokeColor={metric.color}
              showInfo={false}
              strokeWidth={8}
            />
          </div>
        )) : (
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <Text type="secondary">System metrics unavailable</Text>
          </div>
        )}

        {statistics?.system_metrics && (
          <div style={{ marginTop: 12, padding: 12, backgroundColor: 'var(--color-bg-tertiary)', borderRadius: 'var(--radius)' }}>
            <Text strong style={{ fontSize: 11, color: 'var(--color-text-secondary)' }}>NETWORK I/O</Text>
            <div style={{ marginTop: '8px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                <Text style={{ fontSize: '12px' }}>Bytes sent</Text>
                <Text style={{ fontSize: '12px', fontWeight: 600 }}>
                  {formatNumber(statistics.system_metrics.network_bytes_sent)}
                </Text>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Text style={{ fontSize: '12px' }}>Bytes received</Text>
                <Text style={{ fontSize: '12px', fontWeight: 600 }}>
                  {formatNumber(statistics.system_metrics.network_bytes_recv)}
                </Text>
              </div>
            </div>
          </div>
        )}

        {statistics?.system_metrics?.gpu_metrics?.length > 0 && (
          <div style={{ marginTop: 12, padding: 12, backgroundColor: 'var(--color-success-light)', borderRadius: 'var(--radius)' }}>
            <Text strong style={{ fontSize: 11, color: 'var(--color-success)' }}>GPU DETAILS</Text>
            {statistics.system_metrics.gpu_metrics.map((gpu) => (
              <div key={gpu.id} style={{ marginTop: '8px' }}>
                <Text style={{ fontSize: '12px', fontWeight: 600 }}>{gpu.name}</Text>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '4px' }}>
                  <Text style={{ fontSize: '12px' }}>
                    Memory: {gpu.memory_used?.toFixed(0)}MB / {gpu.memory_total?.toFixed(0)}MB
                  </Text>
                  <Text style={{ fontSize: '12px' }}>Temp: {gpu.temperature}°C</Text>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </Card>
  );
}
